// ============================================================================
// Supabase client. If env vars are absent, the app runs in LOCAL mode
// (localStorage) so a developer can `npm run dev` with zero backend setup.
// Add VITE_SUPABASE_URL + VITE_SUPABASE_ANON_KEY to switch to CLOUD mode.
// ============================================================================

import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

let client: SupabaseClient | null = null;

export function isCloud(): boolean {
  return Boolean(url && anon);
}

export function getSupabase(): SupabaseClient | null {
  if (!isCloud()) return null;
  if (!client) client = createClient(url!, anon!);
  return client;
}
